export const EVAL_TYPES = Object.freeze({
  QA: 'qa',
  AGENTIC: 'agentic',
});

export const isValidEvalType = (value) =>
  value === EVAL_TYPES.QA || value === EVAL_TYPES.AGENTIC;

